import styled from 'styled-components/macro';

export const StyledPage = styled.div``;
